import React from 'react';
import swal from 'sweetalert';
import {
  getAuctionImages, uploadImage, getAuctionVideo,
  uploadVideo, removeImage, makeCover,
} from '../../../../../../models/auctions';
import { Spinner } from 'react-bootstrap';
import i18n from '../../../../../../i18n';
import FileInput from '../../../../../helpers/fileInput';
import { Trash2, Eye, Image, Film, Upload } from 'lucide-react';

export class ImagePanelTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auction: {},
      is_loading_video: false,
      is_loading_images: false,
      auctionId: props.auctionId,
      input: {},
      errors: {},
      videoFile: null,
      imageFiles: null,
      images: [],
    };
    this.onFileChange = this.onFileChange.bind(this);
    this.uploadVideo = this.uploadVideo.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    this.removeImage = this.removeImage.bind(this);
    this.makeCover = this.makeCover.bind(this);
  }

  componentDidMount() {
    this.loadAllImages();
    this.loadVideo();
  }

  onFileChange = (event) => {
    if (event.target.name === 'videoFile') {
      this.setState({ videoFile: event.target.files[0] });
    }
    if (event.target.name === 'imageFiles') {
      this.setState({ imageFiles: event.target.files });
    }
  };

  async loadAllImages() {
    this.setState({ is_loading_images: true });
    const response = await getAuctionImages(this.state.auctionId);
    if (response) {
      let images = response.data;
      this.setState({ images, is_loading_images: false });
    }
  }

  async loadVideo() {
    this.setState({ is_loading_video: true });
    const response = await getAuctionVideo(this.state.auctionId);
    let auction = response.data;
    if (auction) {
      this.setState({ auction, is_loading_video: false });
    }
  }

  async uploadVideo(event) {
    event.preventDefault();
    if (!this.state.auctionId || !this.state.videoFile) {
      swal('Failed', 'File Missing', 'error');
      return;
    }
    this.setState({ is_loading_video: true });
    const formData = new FormData();
    formData.append('auction_id', this.state.auctionId);
    if (this.state.videoFile) {
      formData.append('videoFile', this.state.videoFile, this.state.videoFile.name);
    }
    const response = await uploadVideo(formData);
    if (response) {
      this.setState({ is_loading_video: false });
      if (response.success) {
        this.setState({ auction: response.data });
      } else {
        swal('Failed', 'Some error occured!! Please make sure that you are uploading video file.', 'error');
      }
    }
  }

  async uploadImage(event) {
    event.preventDefault();
    let images = this.state.imageFiles;
    if (!this.state.auctionId || !images || !images.length) {
      swal('Failed', 'File Missing', 'error');
      return;
    }
    this.setState({ is_loading_images: true });
    const formData = new FormData();
    formData.append('auction_id', this.state.auctionId);
    for (let i = 0; i < images.length; i++) {
      formData.append('imageFiles[]', images[i]);
    }
    const response = await uploadImage(formData);
    if (response.success) {
      this.setState({ is_loading_images: false });
      this.loadAllImages();
    } else {
      swal('Failed', 'Please make sure the file formats before uploading.', 'error');
    }
  }

  async removeImage(id) {
    const response = await removeImage({ image_id: id, auction: this.state.auctionId });
    if (response.success) { this.loadAllImages(); }
  }

  async makeCover(id) {
    const response = await makeCover({ image_id: id, auction: this.state.auctionId });
    if (response.success) { this.loadAllImages(); }
  }

  render() {
    let images = this.state.images;
    let video = this.state.auction.video;
    return (
      <div>
        {/* Upload Images */}
        <div className="form-section">
          <div className="section-header">
            <h2><Image size={20} style={{ marginRight: '8px', verticalAlign: 'text-bottom' }} />Upload Images</h2>
          </div>
          <p style={{ fontSize: '0.8rem', color: '#6b7280', marginBottom: '16px' }}>
            Allowed Formats: .jpg, .jpeg, .png, .gif, .bmp
          </p>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <div className="form-field" style={{ flex: 1, minWidth: '200px' }}>
              <FileInput wrapperClass="" placeholder={i18n.t('choose_file')} id="imageFiles"
                name="imageFiles" onChange={this.onFileChange} className="form-control" multiple={true} />
            </div>
            <button type="button" className="button1 button1-primary" onClick={this.uploadImage}
              style={{ height: '42px', whiteSpace: 'nowrap' }}>
              <Upload size={16} /> Upload Image(s)
            </button>
          </div>

          {this.state.is_loading_images && (
            <div style={{ textAlign: 'center', padding: '2rem' }}><Spinner animation="border" /></div>
          )}

          {!this.state.is_loading_images && images && images.length > 0 && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '16px', marginTop: '20px' }}>
              {images.map((item, i) => (
                <div key={i} style={{
                  borderRadius: '10px', overflow: 'hidden', border: '1px solid #e5e7eb',
                  background: '#fafafa', position: 'relative'
                }}>
                  {item.is_cover === 1 && (
                    <div style={{
                      position: 'absolute', top: '8px', left: '8px', background: '#10b981',
                      color: '#fff', fontSize: '11px', fontWeight: 600, padding: '2px 8px',
                      borderRadius: '4px', zIndex: 1
                    }}>Cover</div>
                  )}
                  <img src={item.image} alt="" style={{ width: '100%', height: '140px', objectFit: 'cover' }} />
                  <div style={{ padding: '8px', display: 'flex', gap: '4px', flexDirection: 'column' }}>
                    <a href={item.image} target="_new" className="button1 button1-secondary"
                      style={{ fontSize: '12px', padding: '4px 8px', textAlign: 'center', textDecoration: 'none' }}>
                      <Eye size={14} /> {i18n.t('view')}
                    </a>
                    <button type="button" className="button1 button1-secondary"
                      style={{ fontSize: '12px', padding: '4px 8px' }}
                      onClick={() => this.makeCover(item.id)}>
                      <Image size={14} /> Make Cover
                    </button>
                    <button type="button" className="button1 button1-danger"
                      style={{ fontSize: '12px', padding: '4px 8px' }}
                      onClick={() => this.removeImage(item.id)}>
                      <Trash2 size={14} /> {i18n.t('delete')}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Upload Video */}
        <div className="form-section">
          <div className="section-header">
            <h2><Film size={20} style={{ marginRight: '8px', verticalAlign: 'text-bottom' }} />Upload Video</h2>
          </div>
          <p style={{ fontSize: '0.8rem', color: '#6b7280', marginBottom: '16px' }}>
            Formats: mp4, ogx, oga, ogv, ogg, webm
          </p>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <div className="form-field" style={{ flex: 1, minWidth: '200px' }}>
              <FileInput wrapperClass="" placeholder={i18n.t('choose_file')} id="videoFile"
                name="videoFile" onChange={this.onFileChange} className="form-control" />
            </div>
            <button type="button" className="button1 button1-primary" onClick={this.uploadVideo}
              style={{ height: '42px', whiteSpace: 'nowrap' }}>
              <Upload size={16} /> Upload Video
            </button>
          </div>

          {this.state.is_loading_video && (
            <div style={{ textAlign: 'center', padding: '2rem' }}><Spinner animation="border" /></div>
          )}

          {!this.state.is_loading_video && video && (
            <div style={{ marginTop: '16px' }}>
              <video controls style={{ width: '100%', maxWidth: '400px', borderRadius: '8px' }}>
                <source src={video} type="video/mp4" />
                Your browser does not support HTML video.
              </video>
            </div>
          )}
        </div>
      </div>
    );
  }
}